import { useContext } from 'react'

import { GalleryContextMenuContext } from '../contexts'

export default () => useContext(GalleryContextMenuContext)
